<!--
 * @Description: 
 * @FilePath: \京东互动积分B端\src\views\integralCenter\NewHome\page_home.vue
-->
<template>
  <div class="integral_Home_content">
    <!-- <div> -->
    <div class="glurLeft">
      <!-- 左边模块 -->
      <div class="left">
        <div class="hot hotImg">热门推荐</div>
        <!-- 公告 -->
        <div class="modular_Adsense">
          <div
            class="modular_content"
            v-for="item in popularList"
            :key="item.id"
          >
            <div class="content_top">
              <div class="content_img">
                <img
                  v-if="item.id != 2"
                  style="width: 100%; height: 320px"
                  :src="item.img"
                  alt=""
                />
                <el-carousel v-else style="height: 320px;" indicator-position="none" arrow="never">
                  <el-carousel-item style="height: 100%;" v-for="item1 in item.imgList" :key="item1">
                    <img style="width: 100%; height: 100%" :src="item1" alt="" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="content_bgimg">
                <div class="adsense_wz">
                  <div class="adsense_cont">
                    {{ item.des }}
                  </div>
                  <div class="adsense_btn pointer" @click="handleCreate(item)">
                    立即创建
                  </div>
                </div>
              </div>
            </div>
            <div class="content_bottom">
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="hot mapImg">能力地图</div>
        <!-- 能力地图 -->
        <div class="modular_QuickEntrance">
          <div class="ability_map" v-for="item in mapList" :key="item.id">
            <div class="ability_top">
              <img :src="item.logo" style="margin-right: 3px" alt="" />
              {{ item.name }}
            </div>
            <div class="ability_bottom">
              <div class="action" v-for="val in item.children" :key="val.id">
                <div class="action_img">
                  <img :src="val.icon" alt="" />
                </div>
                <div class="action_js">
                  <div class="action_js_wz">
                    {{ val.name }}
                  </div>
                  <div class="action_js_btn pointer" @click="handleCreate(val)">
                    立即创建
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="glurRight">
      <!-- 右边模块 -->
      <div class="right">
        <!-- 店铺信息 -->
        <div class="shop_Details">
          <div class="information">
            <div class="information_img">
              <!-- <img src="@/assets/thdImg/home/shop.svg" alt="" /> -->
              <img
                style="width: 100%"
                :src="shopDetails.picPath"
                v-if="shopDetails.picPath"
                alt=""
              />
              <img src="@/assets/thdImg/home/shop.svg" v-else alt="" />
            </div>
            <div class="information_js">
              <div class="information_js_wz">
                {{ shopDetails.sellerNick }}
              </div>
              <div class="information_js_btn">
                {{ shopDetails.versionName }}
              </div>
            </div>
          </div>
          <div class="information_hd">
            <div class="information_wz">
              <span class="information_wz_name">小程序授权状态</span>
              <span
                class="spanColor"
                :style="{
                  color: shopDetails.minAppAuthState ? '#2670fb' : '#F56C6C',
                }"
              >
                {{ shopDetails.minAppAuthState ? "已授权" : "未授权" }}</span
              >
            </div>
            <div class="information_wz">
              <span class="information_wz_name">强制入会</span>
              <span class="spanColor">
                <el-switch
                  v-model="shopDetails.openCardStatus"
                  @change="hanldeSwitch"
                >
                </el-switch>
              </span>
            </div>
            <div class="information_wz" style="align-items: center">
              <span class="information_wz_name">小程序名称</span>
              <span v-if="minAppNamedit" class="spanColor">{{
                shopDetails.minAppName
              }}</span>
              <el-input
                v-else
                v-model="shopDetails.minAppName"
                type="text"
                style="width: 120px"
              ></el-input>
              <i
                v-if="minAppNamedit"
                @click="minAppNamedit = false"
                class="el-icon-edit-outline pointer"
                style="color: #2670fb; margin-left: 6px; margin-top: 3px"
              ></i>
              <i
                v-else
                class="el-icon-circle-check pointer"
                @click="handleEnter()"
                style="color: #67c23a; margin-left: 6px"
              ></i>
            </div>
            <div class="information_wz">
              <span class="information_wz_name">进行中的玩法</span>
              <span class="spanColor">{{ progressActivity }}</span>
            </div>
            <div class="information_wz">
              <span class="information_wz_name">累计设置玩法</span>
              <span class="spanColor">{{ activityCount }}</span>
            </div>
          </div>
        </div>

        <div class="customer_service">
          <!-- 轮播图 -->
          <div class="poster">
            <el-carousel>
              <el-carousel-item v-for="item in bannerList" :key="item.id">
                <img :src="item.imgUrl" @click="handleBanner(item)" />
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 联系客服 -->
          <div class="contact">
            <div class="contact_title mapImg">联系客服</div>
            <div class="contact_wz">热线电话：020-28970151</div>
            <div class="contact_wz">周末客服：18925068928</div>
            <!-- <div class="contact_wz">咚咚咨询：dd_1jm8pmp5oonqa</div> -->
            <div class="contact_wz qq_service">
              旺旺咨询：
              <span @click="on_QQ(1)" class="service1 pointer">客服1</span>
              <span @click="on_QQ(2)" class="service1 pointer">客服2</span>
            </div>
            <div class="contact_wz">微信咨询：yunduanxin-yunqi</div>
            <div class="contact_code">
              <img
                src="@/assets/images/integralCenter/NewHome/code-three.png"
                alt=""
              />
              <img
                src="@/assets/images/integralCenter/NewHome/code-three.png"
                alt=""
              />
            </div>
            <div class="contact_manual">
              <div class="contact_manual_btn pointer" @click="handleWord('1')">
                使用手册
              </div>
              <div class="contact_manual_btn pointer" @click="handleWord('1')">
                智能问答
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <!-- 系统提示 -->
    <system-dialog
      v-if="userphoneVisible"
      @close="closeSystemTip"
    ></system-dialog>
  </div>
</template>

<script>
// import { get as post } from "../../../api/axios2";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import systemDialog from "@/components/system-dialog";
import { querySellerSetting } from "@/api/userInform"; //判断是否有绑定手机号
import { getHomeGetCarousel } from "@/api/homePage";
import { getSellerInfo } from "@/api/sellerController";
import { getActivityCount, updateMemberCenterURL, taohdName } from "@/api/thd";

export default {
  name: "pageHome",

  data() {
    return {
      minAppNamedit: true,
      popularList: [
        {
          id: "1",
          name: "首购有礼",
          path: "integralEden/firstPurchase?activityType=17",
          des: "通过首购有礼权益，商家可对会员进行首购奖励，从而有效的提升会员转化、复购率。",
          img: require("@/assets/thdImg/home/hot_sgyl.svg"),
          bgimg: "",
        },
        {
          id: "3",
          name: "复购有礼",
          path: "integralEden/firstPurchase?activityType=18",
          des: "通过复购有礼权益，商家可对会员进行复购奖励，从而有效的提升会员转化、复购率。",
          img: require("@/assets/thdImg/home/hot_fgyl.svg"),
          bgimg: "",
        },
        {
          id: "4",
          name: "裂变神券",
          path: "integralTask/fission?activityType=21",
          des: "通过社交分享，邀请好友组团领券，成功裂变涨粉",
          img: require("@/assets/thdImg/home/hot_lbsq.svg"),
          bgimg: "",
        },
        {
          id: "5",
          name: "疯狂抓娃娃",
          path: "gameHub/prizeClaw?activityType=23",
          des: "新奇趣味的在线抓娃娃游戏，玩游戏的同时赢取礼品，增加客户留存以及提升客户的粘性",
          img: require("@/assets/thdImg/home/hot_zww.svg"),
          bgimg: "",
        },
        {
          id: "6",
          name: "大家来找茬",
          path: "gameHub/differences?activityType=24",
          des: "“大家来找茬”是一款热门休闲的游戏，在限定时间内，找出两幅图的不同之处，通关后即可参与抽奖赢取礼品",
          img: require("@/assets/thdImg/home/hot_zc.svg"),
          bgimg: "",
        },
        {
          id: "2",
          name: "幸运大抽奖",
          path: "interesting/turntable?activityType=8",
          des: "缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度二维",
          imgList: [
            require("@/assets/thdImg/home/hot_dzp.svg"),
            require("@/assets/thdImg/home/hot_jgg.svg"),
          ],
          bgimg: "",
        },
      ],
      mapList: [
        {
          id: "1",
          logo: require("@/assets/thdImg/home/lx.svg"),
          name: "拉新",
          children: [
            {
              id: "1-1",
              name: "疯狂抓娃娃",
              icon: require("@/assets/thdImg/home/lx_kclb.svg"),
              path: "gameHub/prizeClaw?activityType=23",
            },
            {
              id: "1-2",
              name: "完善信息有礼",
              icon: require("@/assets/thdImg/home/lx_dplb.svg"),
              path: "integralTask/perfectNews?activityType=6",
            },
            {
              id: "1-3",
              name: "关注店铺有礼",
              icon: require("@/assets/thdImg/home/lx_gzdp.svg"),
              path: "integralTask/followShop?activityType=3",
            },
          ],
        },
        {
          id: "2",
          logo: require("@/assets/thdImg/home/hy.svg"),
          name: "活跃",
          children: [
            {
              id: "2-1",
              name: "天降红包雨",
              icon: require("@/assets/thdImg/home/hy_tjhby.svg"),
              path: "integralTask/redPacket?activityType=22",
            },
            {
              id: "2-2",
              name: "幸运大抽奖",
              icon: require("@/assets/thdImg/home/hy_dzp.svg"),
              path: "interesting/turntable?activityType=8",
            },
            {
              id: "2-3",
              name: "每日抢好礼",
              icon: require("@/assets/thdImg/home/hy_mrqhl.svg"),
              path: "integralTask/Grabgifts?activityType=2",
            },
          ],
        },
        {
          id: "3",
          logo: require("@/assets/thdImg/home/zh.svg"),
          name: "转化",
          children: [
            {
              id: "3-1",
              name: "首购有礼",
              icon: require("@/assets/thdImg/home/zh_sgyl.svg"),
              path: "integralEden/firstPurchase?activityType=17",
            },
            {
              id: "3-2",
              name: "下单有礼",
              icon: require("@/assets/thdImg/home/zh_xdyl.svg"),
              path: "integralEden/overbooking?activityType=16",
            },
            {
              id: "3-3",
              name: "下单抽奖",
              icon: require("@/assets/thdImg/home/zh_xdcj.svg"),
              path: "integralEden/lottergdraw?activityType=19",
            },
          ],
        },
        {
          id: "4",
          logo: require("@/assets/thdImg/home/lc.svg"),
          name: "留存",
          children: [
            // {
            //   id: "4-1",
            //   name: "评价有礼",
            //   icon: require("@/assets/thdImg/home/lc_pjyl.svg"),
            //   path: "",
            // },
            {
              id: "4-1",
              name: "下单有礼",
              icon: require("@/assets/thdImg/home/zh_xdyl.svg"),
              path: "integralEden/overbooking?activityType=16",
            },
            {
              id: "4-2",
              name: "复购有礼",
              icon: require("@/assets/thdImg/home/lc_fgyl.svg"),
              path: "integralEden/fgPurchase?activityType=18",
            },
            {
              id: "4-3",
              name: "会员专属券",
              icon: require("@/assets/thdImg/home/lc_hyzs.svg"),
              path: "",
            },
          ],
        },
        {
          id: "5",
          logo: require("@/assets/thdImg/home/lb.svg"),
          name: "裂变",
          children: [
            {
              id: "5-1",
              name: "邀请开卡",
              icon: require("@/assets/thdImg/home/lb_yqkc.svg"),
              path: "integralTask/inviteCard?activityType=4",
            },
            {
              id: "5-2",
              name: "裂变神券",
              icon: require("@/assets/thdImg/home/lb_lbsq.svg"),
              path: "integralTask/fission?activityType=21",
            },
            {
              id: "5-3",
              name: "疯狂抓娃娃",
              icon: require("@/assets/thdImg/home/lb_zww.svg"),
              path: "gameHub/prizeClaw?activityType=23",
            },
          ],
        },
      ],
      TimeRenew: false, //是否显示悬浮框
      shopDetails: {}, //店铺信息
      userphoneVisible: false, //弹窗
      bannerList: [], //轮播图
      progressActivity: 0,
      activityCount: 0,
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "云起互动", "首页", "首页");
    this.TimeRenew = sessionStorage.getItem("TimeRenew")
      ? sessionStorage.getItem("TimeRenew")
      : false;

    // 轮播图广告位 高度自适应
    var fun_poster = function fun_poster() {
      let my_div =
        document.getElementsByClassName("poster")[0].childNodes[0]
          .childNodes[0];
      let width = document.defaultView.getComputedStyle(my_div, null);
      // console.log('width',Math.round(parseInt(width.width) * 0.48))
      my_div.style.maxHeight = Math.round(parseInt(width.width) * 0.48) + "px";
    };
    window.onresize = function () {
      fun_poster();
    };
    setTimeout(() => {
      fun_poster();
    }, 200);
    getHomeGetCarousel({ type: 1, platform: 2 }).then((res) => {
      this.bannerList = res.data.list;
    });
  },
  mounted() {
    this.getUser();
    // this.querySellerSetting();
  },

  methods: {
    handleEnter() {
      taohdName({ name: this.shopDetails.minAppName }).then((res) => {
        this.minAppNamedit = true;
        this.getUser();
      });
    },
    handleCreate(item) {
      if (item.name == "会员专属券") {
        window.open(
          "https://ecrm.taobao.com/jxt/jxtHomepage.htm?#//tbpassport.taobao.com/member/benefit/#/&spm=a1za3.9124792",
          "_blank"
        );
      } else {
        this.$router.push({ path: item.path });
      }
    },
    async getUser() {
      let { data } = await getSellerInfo();
      let { data: res } = await getActivityCount();
      // console.log('data',data)
      this.progressActivity = res.progressActivity;
      this.activityCount = res.activityCount;
      this.shopDetails = {
        ...data,
        expiredIn: data.softwareExpire,
        invalidateDate: data.softwareExpire,
        sellerNick: data.shopTitle,
        sellerPin: data.shopTitle,
      };
      this.$store.state.loginUserInfo = {
        ...data,
        expiredIn: data.softwareExpire,
        invalidateDate: data.softwareExpire,
        sellerNick: data.shopTitle,
        sellerPin: data.shopTitle,
      };
    },
    hanldeSwitch(value) {
      updateMemberCenterURL({ status: value }).then((res) => {
        if (res.data.code == 1 || res.code == 1) {
        } else {
          this.shopDetails.openCardStatus = !value;
          this.$message.warning(res.data.message || res.message);
        }
      });
      this.getUser();
    },
    // get_getPoint() {
    //   return post(`/mainInfoController/getSoftwareInfo`);
    // },

    // 判断是否需要填写联系人信息
    closeSystemTip() {
      this.userphoneVisible = false;
    },
    querySellerSetting() {
      querySellerSetting({})
        .then((res) => {
          this.userInfo = res.data;
          if (res.data.mobile == "" || !res.data.mobile) {
            this.userphoneVisible = true;
          }
        })
        .catch((e) => {});
    },

    //时间方法
    p_newData(dataTime) {
      const d = new Date(dataTime);
      return (
        d.getFullYear() +
        "-" +
        this.p_DateTime(d.getMonth() + 1) +
        "-" +
        this.p_DateTime(d.getDate())
      );
    },
    p_DateTime(s) {
      return s < 10 ? "0" + s : s;
    },
    ////////////////////////////////////////////////////////////////////////////////
    //判断图片是否有效
    imgError(url, item, urlName) {
      item[urlName] = "";
    },

    on_renew() {
      const href = "https://fw.jd.com/main/detail/FW_GOODS-1415006";
      window.open(href, "_blank");
    },
    on_banner() {
      const href = "https://www.wjx.top/vj/hD8iioY.aspx";
      window.open(href, "_blank");
    },
    on_QQ(num) {
      if (num == 1) {
        const href =
          "https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=美滴生活&site=cntaobao";
        window.open(href, "_blank");
      } else {
        const href =
          "https://amos.im.alisoft.com/msg.aw?spm=a1z13.2196529.0.0.7bc05acabYifbq&v=2&uid=scofieldr%3Ayeion&site=cntaobao&s=1&charset=utf-8";
        window.open(href, "_blank");
      }
    },
    close_TimeRenew() {
      (this.TimeRenew = false), sessionStorage.removeItem("TimeRenew");
    },

    //快捷入口 ,
    on_QuickEntrance(path, type) {
      // const res = await prefixurl();
      const query = {
        type: type,
        // url:JSON.stringify(res.data.activityUrl),
        // venderId:res.data.venderId,
      };
      this.$router.push({ path: path, query: query });
    },
    // 轮播图跳转
    handleBanner(item) {
      if (item.pathType == 1) {
        this.$router.push(item.pathUrl);
      } else if (item.pathType == 0) {
        window.open(item.pathUrl, "_blank");
      }
    },
    handleWord(num) {
      if (num === "1") {
        window.open(
          "https://www.yuque.com/books/share/bf5aa7f4-4f43-4a23-a0c4-c8e26e61b46e?# 《操作手册-淘互动》",
          "_blank"
        );
      } else {
        window.open(
          "https://www.yuque.com/books/share/bf5aa7f4-4f43-4a23-a0c4-c8e26e61b46e?# 《操作手册-淘互动》",
          "_blank"
        );
      }
    },
  },
  components: {
    systemDialog,
  },
};
</script>
<style lang="scss" scoped>
.integral_Home_content {
  width: 100%;
  padding: 30px 20px 20px 20px;
  display: flex;
  min-width: 1080px;
  .glurLeft {
    flex: 1;
    // height: 829px;
    margin-right: 24px;
    // overflow: hidden;
  }
  .glurRight {
    // height: 829px;
    width: 424px;
    overflow: hidden;
    min-width: 242px;
  }
  .mapImg::before {
    content: "";
    width: 2px;
    height: 16px;
    background: #2670fb;
    border-radius: 1px 1px 1px 1px;
    margin-right: 8px;
  }
  .left {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-flow: column wrap;
    justify-content: flex-start;
    // overflow: hidden;
    .hot {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 21px;
      padding: 0px 10px 15px 10px;
      display: flex;
      align-items: center;
    }
    .hotImg::before {
      content: "";
      width: 19px;
      height: 19px;
      background: url("../../../assets/thdImg/home/hot.svg") no-repeat;
      // display: inline-block;
      margin-right: 4px;
    }

    .modular_Adsense {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      padding: 0 7px;
      .modular_content {
        width: 184px;
        height: 368px;
        .content_top {
          width: 100%;
          height: 336px;
          background: rgba(255, 255, 255, 0.2);
          box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          border: 1px solid #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .content_img {
            width: 168px;
            height: 323px;
            // background: #7f85e9;
            /deep/ .el-carousel__container{
              height: 320px;
            }
          }
          &:hover .content_bgimg {
            display: block;
          }
          .content_bgimg {
            display: none;
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0);
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #2670fb;
            box-sizing: content-box;
            overflow: hidden;
            z-index: 99;
          }
          .adsense_wz {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 104px;
            background: rgba(255, 255, 255, 0.85);
            box-shadow: 0px -4px 10px 1px rgba(0, 0, 0, 0.2);
            border-radius: 0px 0px 12px 12px;
            .adsense_cont {
              width: 100%;
              height: 76px;
              font-size: 12px;
              color: #333333;
              padding: 6px;
              line-height: 16px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; /*重点，不能用block等其他*/
              -webkit-line-clamp: 4; /*重点IE和火狐不支持*/
              -webkit-box-orient: vertical; /*重点*/
              -webkit-line-clamp: 4;
            }
            .adsense_btn {
              width: 100;
              height: 34px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #2670fb;
              color: #ffffff;
              border-radius: 0px 0px 12px 12px;
              &::after {
                content: "";
                width: 14px;
                height: 14px;
                margin-left: 6px;
                background: url("../../../assets/thdImg/home/create.svg")
                  no-repeat;
              }
            }
          }
        }
        .content_bottom {
          width: 100%;
          height: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #222222;
        }
      }
    }

    .modular_QuickEntrance {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .ability_map {
        width: 226px;
        height: 355px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        overflow: hidden;
        .ability_top {
          width: 100%;
          height: 46px;
          border-radius: 12px 12px 0px 0px;
          border-bottom: 1px solid #f1f3ff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
        }
        .ability_bottom {
          width: 100%;
          height: calc(355px - 46px);
          padding: 10px 0;
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
        }
        .action {
          width: 100%;
          // background: green;
          height: 92px;
          padding: 18px 0 18px 16px;
          display: flex;
          &_img {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background: rgba(249, 114, 74, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &_js {
            width: 100%;
            flex: 1;
            padding: 4px 10px;
            &_wz {
              color: #333333;
              font-size: 16px;
              margin-bottom: 8px;
            }
            &_btn {
              width: 72px;
              height: 25px;
              font-size: 12px;
              background: rgba(38, 112, 251, 0.1);
              border-radius: 4px 4px 4px 4px;
              color: #2670fb;
              text-align: center;
              line-height: 25px;
              &:hover {
                background: #2670fb;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-flow: column wrap;
    justify-content: flex-start;
    overflow: hidden;
    .shop_Details {
      width: 100%;
      height: 235px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      margin-bottom: 20px;
      .information {
        width: 100%;
        // background: green;
        height: 80px;
        padding: 10px 0 0 24px;
        border: 1px solid #f1f3ff;
        display: flex;
        &_img {
          width: 48px;
          height: 48px;
          min-width: 48px;
          border-radius: 50%;
          // background: #f88d3b;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &_js {
          width: 100%;
          flex: 1;
          padding: 4px 10px;
          &_wz {
            color: #333333;
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 8px;
            min-width: 148px;
            width: 323px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          &_btn {
            width: 60px;
            height: 21px;
            line-height: 21px;
            text-align: center;
            background: #fff1e9;
            color: #653517;
            font-size: 12px;
            border-radius: 21px 21px 21px 21px;
          }
        }
      }
      .information_hd {
        width: 100%;
        padding: 10px 0 0 24px;
        font-size: 14px;
        .information_wz {
          color: #333333;
          height: 28px;
          line-height: 28px;
          min-width: 215px;
          display: flex;
          &_name {
            width: 120px;
          }
        }
        .spanColor {
          // margin-left: 30px;
          color: #2670fb;
        }
      }
    }

    .customer_service {
      width: 100%;
      height: 578px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      padding: 12px;
      .contact {
        width: 100%;
        &_title {
          margin-bottom: 16px;
          font-size: 18px;
          color: #333333;
          font-weight: 600;
          display: flex;
          align-items: center;
        }
        &_wz {
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #666666;
          min-width: 218px;
        }
        &_code {
          height: 100px;
          width: 184px;
          margin-left: 64px;
          display: flex;
        }
        &_manual {
          width: 98%;
          display: flex;
          margin-top: 8px;
          justify-content: space-between;
          &_btn {
            width: 192px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: #ffffff;
            color: #2670fb;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #2670fb;
          }
        }
        .qq_service {
          display: flex;
          // padding-left: 5px;
        }
        .service1 {
          font-size: 12px;
          width: 69px;
          height: 25px;
          background: #2670fb;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          margin-right: 8px;
          border-radius: 4px 4px 4px 4px;
          &::before {
            content: "";
            width: 12px;
            height: 12px;
            margin-right: 3px;
            background: url("../../../assets/thdImg/home/service.svg") no-repeat;
          }
        }
      }
    }

    .poster {
      width: 100%;
      min-width: 218px;
      // height: 275px;
      border-radius: 8px;
      margin-bottom: 24px;
      /deep/.el-carousel {
        .el-carousel__container {
          height: 221px;
          .el-carousel__item {
            cursor: pointer;
            img {
              width: 100%;
            }
          }
        }
        .el-carousel__indicators {
          margin-top: 10px;
          .el-carousel__button {
            background: #fff;
            border-radius: 50%;
            width: 4px;
            height: 4px;
          }
          .is-active .el-carousel__button {
            width: 18px;
            border-radius: 6px;
            opacity: 1;
          }
        }
      }
      /deep/.el-carousel__arrow {
        display: none !important;
      }
    }
  }
}

// @media screen and (min-width: 1340px) and (max-width: 1540px) {
//   .integral_Home_content {
//     .left {
//     }
//     .right {
//     }
//   }
// }

@media screen and (max-width: 1540px) {
  .integral_Home_content {
    .left {
      .modular_content {
        width: 176px !important;
        &:last-child {
          display: none;
        }
      }
      .content_img {
        width: 161px !important;
      }
      .ability_map {
        width: 177px !important;
      }
    }
    .glurRight {
      width: 242px;
    }
    .contact_code {
      margin-left: 0 !important;
    }
    .information_js_wz {
      width: 148px !important;
    }
    .contact_manual {
      display: block !important;
      > div {
        width: 205px !important;
      }
      .contact_manual_btn:first-child {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
